export const animations = {
  slideInRight: {
    animation: 'slideInRight',
    animationName: 'slideInRight',
  },
};
